import type { InferRequestType, InferResponseType } from 'hono/client';
import { type ApiClient, type ReadToastOptions, useFetch } from '../api';

type ListNetworkConfigs = ApiClient['v2']['workspaces'][':workspaceId']['network-configs']['$get'];
export type NetworkConfigListResponse = InferResponseType<ListNetworkConfigs, 200>;
export type NetworkConfigResponse = NetworkConfigListResponse['networkConfigs'][number];
export type NetworkConfigListQuery = NonNullable<InferRequestType<ListNetworkConfigs>['query']>;

export function useWorkspaceNetworkConfigs(
  workspaceId: number,
  params: NetworkConfigListQuery = {},
  toastOptions?: ReadToastOptions
) {
  return useFetch<NetworkConfigListResponse>(
    `workspaces/${workspaceId}/network-configs?${JSON.stringify(params)}`,
    (client) =>
      client.v2.workspaces[':workspaceId']['network-configs'].$get({
        param: { workspaceId: workspaceId.toString() },
        query: params,
      }),
    toastOptions,
    { keepPreviousData: true }
  );
}
